






import Vue from 'vue';
import QuoteDetail from '@/components/quotes/QuoteDetail.vue';

export default Vue.extend({
  name: 'QuoteDetailPage',

  components: { QuoteDetail },

  computed: {
    quoteId(): number {
      return Number(this.$route.params.quoteId);
    },
    quoteRevision(): number {
      return Number(this.$route.params.quoteRevision);
    }
  }
});
